import { Space, Text } from "@/atoms"
import { ArrowRightOutlined } from "@/icons"
import { Item, List } from "@/pages/DiscoveryPage/components/molecules/List"

import styles from "./SourceList.module.scss"

import { useTranslation } from "@/hooks/useTranslation"
import type { IntroducedThroughFixes } from "."

export const IntroducedThroughFixesItem = ({
  introducedThrough,
  packageName,
  fixVersion,
  noLimits,
  tKey
}: IntroducedThroughFixes) => {
  const { t } = useTranslation()
  const classes = {
    value: styles.fixIndirectHintValue,
    item: styles.fixItem
  }

  return (
    <List
      classes={{
        list:
          introducedThrough.length > 1 ? styles.itemList : styles.oneItemList,
        button: styles.button
      }}
      items={introducedThrough}
      limit={noLimits ? undefined : 2}
      render={(packageRecord) => {
        const { name, version: currentVersion } = packageRecord[0]
        const nameVersionText = `${name}${currentVersion ? `:${currentVersion}` : ""}`
        const helpValueText = `${name} (${t(`${tKey}upgradeIndirectHelp`, { packageName, fixVersion })})`

        // Used for copy fix
        if (noLimits) {
          return <Item title={`${nameVersionText} -> ${helpValueText}`} />
        }

        return (
          <Item
            classes={classes}
            title={
              <Space size={4} inline>
                <Text className={styles.fixTitleCurrentValue}>
                  {nameVersionText}
                </Text>
                <ArrowRightOutlined className={styles.fixTitleArrow} />
              </Space>
            }
            value={helpValueText}
          />
        )
      }}
    />
  )
}
